// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"6b3feec1","86":"1903d8d4","88":"bd41b395","115":"3e3d0024","185":"a52ce94e","247":"0a9a74cf","428":"ec19d0e0","512":"8b932579","536":"9280c480","625":"248d112e","878":"58cf2661"}[chunkId] + ".chunk.js";
};